<script setup>
	import { computed, onErrorCaptured, onMounted, ref } from "vue";
	import VibeCodePromotionTerminal from "@/views/VibeCodePromotionTerminal.vue";
	import VibeCodePromotionClassic from "@/views/VibeCodePromotionClassic.vue";
	import { trackPromoVariantView } from "@/services/analytics";

	const variantStorageKey = "vibeCodePromotionVariant";

	const variantComponents = {
		terminal: VibeCodePromotionTerminal,
		classic: VibeCodePromotionClassic,
	};

	const variantPages = {
		terminal: "/vibe-code-promotion-terminal",
		classic: "/vibe-code-promotion-classic",
	};

	const variantNames = Object.keys(variantComponents);
	const failedVariants = [];

	function readOverrideVariant() {
		try {
			const requestedVariant = new URLSearchParams(window.location.search).get("variant");
			return requestedVariant && variantNames.includes(requestedVariant) ? requestedVariant : null;
		} catch {
			return null;
		}
	}

	function readStoredVariant() {
		try {
			return window.localStorage.getItem(variantStorageKey);
		} catch {
			return null;
		}
	}

	function persistVariant(variant) {
		try {
			window.localStorage.setItem(variantStorageKey, variant);
		} catch {
		}
	}

	function resolveVariant() {
		const overrideVariant = readOverrideVariant();
		if (overrideVariant) {
			return overrideVariant;
		}

		const storedVariant = readStoredVariant();
		if (storedVariant && variantNames.includes(storedVariant)) {
			return storedVariant;
		}

		const randomVariant = variantNames[Math.floor(Math.random() * variantNames.length)];
		persistVariant(randomVariant);

		return randomVariant;
	}

	const activeVariant = ref(resolveVariant());

	const activeVariantComponent = computed(() => variantComponents[activeVariant.value]);

	onMounted(() => {
		trackPromoVariantView(variantPages[activeVariant.value]);
	});

	onErrorCaptured((error) => {
		console.error(`[vibe-code-promotion] the "${activeVariant.value}" variant failed to render:`, error);

		if (!failedVariants.includes(activeVariant.value)) {
			failedVariants.push(activeVariant.value);
		}

		const fallbackVariant = variantNames.find((variantName) => !failedVariants.includes(variantName));

		if (fallbackVariant) {
			persistVariant(fallbackVariant);
			activeVariant.value = fallbackVariant;
			trackPromoVariantView(variantPages[fallbackVariant]);
		}

		return false;
	});
</script>

<template>
	<component :is="activeVariantComponent" />
</template>